import { saveAs } from "file-saver";

export const download = (name, response) => {
  const blob = new Blob([response.data], {
    type: response.data.type
  });
  saveAs(blob, name + "." + getFileExtension(response.data.type));
};

export const getFileExtension = (type) => {
  return type.slice(type.indexOf("/") + 1);
};

export const saveURLs = (url, fileName) => {
  saveAs(url, fileName);
};

export default {
  download,
  saveURLs,
};
